import type { UserDto, UserStatus } from '@/lib/api';

export const ROLE_LABEL: Record<UserDto['role'], string> = {
  CUSTOMER: 'Pelanggan',
  STAFF: 'Staf',
  ADMIN: 'Admin',
  SUPER_ADMIN: 'Super admin',
};

export const USER_STATUS_LABEL: Record<UserStatus, string> = {
  ACTIVE: 'Aktif',
  SUSPENDED: 'Ditangguhkan',
};
